<script setup lang="ts">
import { computed, ref } from 'vue';

const $props = defineProps<{
  modelValue?: boolean;
  toggleAccept?: boolean;
}>();

const $slots = defineSlots<{
  activator: (props: { toggleDialog: () => void }) => any;
}>();

const $emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'accept'): void;
}>();

const internalModel = ref(false);
const tab = ref('sozlesme'); // Sekme yönetimi için

const dialogModel = computed({
  get: () => (!$slots.activator ? $props.modelValue : internalModel.value),
  set: (val: boolean) => {
    if (!$slots.activator) {
      $emit('update:modelValue', val);
    } else {
      internalModel.value = val;
    }
  },
});

function toggleDialog() {
  dialogModel.value = !dialogModel.value;
}

function accept() {
  $emit('accept');
  if ($props.toggleAccept) {
    toggleDialog();
  }
}
</script>

<template>
  <span class="terms-and-agreement-dialog--activator">
    <slot name="activator" :toggleDialog="toggleDialog" />
  </span>

  <q-dialog v-model="dialogModel" persistent>
    <q-card style="width: 700px; max-width: 90vw">
      <q-card-section>
        <h1 class="text-h6">KVKK ve Açık Rıza</h1>
      </q-card-section>

      <q-separator />

      <q-card-section>
        <div class="scroll-area">
          <h1 class="text-h6">Kişisel Verilerin Korunması Bilgilendirme Metni ve Açık Rıza</h1>

          <p>İşbu KVKK Uyarınca Bilgilendirme metni temel olarak 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca;</p>
          <ul>
            <li>
              www.hazeljewellery.com internet sitesi (“Site”) aracılığı ile ne tür veriler topladığını, toplanan verilerinizin nasıl kullanıldığını ve Hazel Jewellery’in
              verilerinizi kimlerle paylaşabileceğini,
            </li>
            <li>Hazel Jewellery’in işlediği veriler üzerindeki haklarınızın neler olduğunu ve bu hakları nasıl kullanabileceğinizi,</li>
            <li>Elektronik ticari ileti alma konusundaki olumlu veya olumsuz tercihlerinizi nasıl değiştirebileceğinizi açıklamaktadır.</li>
          </ul>

          <h2>Toplanan Kişisel Veriler ve İşleme Amaçları</h2>
          <p>
            Siz Üyelerimiz’e daha iyi hizmet verebilmek; sipariş süreçlerinizi yürütmek, tamamlamak ve sizlerle ilgili iletişimi sağlamak; sizlere ürünler, hizmetler,
            kampanyalar ve promosyonlarla ilgili bilgi vermek; alışveriş tercihlerinizi daha iyi anlamak, trend analizleri ve istatistiksel analizler yapmak ve Site’nin
            güvenliğini güçlendirmek amacıyla ve ilgili mevzuattan kaynaklanan yasal yükümlülüklerimizi yerine getirme amacıyla adınız, soyadınız, e-posta adresiniz,
            telefon numaranız, cinsiyetiniz, doğum tarihiniz, T.C. kimlik numaranız, vergi kimlik numaranız, kişisel ilgi alanlarınız, fatura ve teslimat adresleriniz;
            sosyal medya hesaplarıyla bağlanmanız durumunda o kanallar aracılığıyla paylaşılmasına onay verilen bilgiler de dahil olmak üzere kişisel verilerinizi
            işlemekteyiz.
          </p>

          <p>
            Bu veriler haricinde, Site ziyaret sıklığı ve zamanları, sipariş verilme zamanları ve sipariş anındaki IP adresi gibi kişisel bilgi içermeyen toplu
            istatistiksel verileri de ziyaretçi hareket ve tercihlerini analiz etmek amacıyla toplamaktayız.
          </p>

          <h2>Kişisel Verilerin İşlenmesi ve Yurt Dışına Aktarımı</h2>
          <p>
            Şirketimiz, sunduğu hizmetler kapsamında elde ettiği kişisel verileri, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) başta olmak üzere ilgili
            mevzuata uygun şekilde işlemektedir.
          </p>

          <h3>1. Veri İşleme Amaçları</h3>
          <p>Toplanan kişisel veriler;</p>
          <ul>
            <li>Hizmetlerin sunulması,</li>
            <li>Sistemlerin çalıştırılması,</li>
            <li>Müşteri ilişkilerinin yürütülmesi,</li>
            <li>Teknik altyapı süreçlerinin yönetilmesi</li>
          </ul>
          <p>amaçlarıyla işlenmektedir.</p>

          <h3>2. Veri İşleyen Kullanımı</h3>
          <p>
            Şirketimiz, teknik altyapı hizmetleri kapsamında yurt dışında bulunan hizmet sağlayıcı firmalardan destek almaktadır. Bu kapsamda, veri barındırma (hosting)
            hizmeti alınan <strong>Hetzner Online GmbH (Almanya)</strong> firması, KVKK kapsamında “veri işleyen” sıfatıyla hareket etmektedir. Hetzner ile aramızda
            imzalanmış olan Veri İşleme Anlaşması (DPA) kapsamında Hetzner, kişisel verilerinizi sadece bizim verdiğimiz talimatlar doğrultusunda ve GDPR standartlarında
            işlemektedir.
          </p>

          <h3>3. Yurt Dışına Veri Aktarımı</h3>
          <p>
            Kişisel veriler, hizmetlerin sağlanabilmesi amacıyla KVKK’nın 9. maddesi uyarınca açık rızanız alınmak suretiyle veya Kanun’da öngörülen diğer hukuki
            sebeplere dayanarak yurt dışına aktarılabilmektedir. Hetzner tarafından sağlanan altyapı, Avrupa Birliği veri koruma mevzuatı (GDPR) kapsamında yüksek
            güvenlik standartlarına sahiptir. <strong>EU server location</strong> seçtiğiniz takdirde verileriniz
            <strong>yalnızca Avrupa Birliği içinde (Almanya)</strong> işlenmekte ve hiçbir üçüncü ülkeye aktarılmamaktadır.
          </p>

          <h3>4. Veri Güvenliği</h3>
          <p>
            Şirketimiz, kişisel verilerin güvenliğini sağlamak amacıyla Hetzner DPA’sında belirtilen teknik ve idari tedbirleri (şifreleme, erişim kontrolü, loglama,
            sunucu güvenliği, fiziksel güvenlik vb.) uygulamaktadır.
          </p>

          <h2>Haklarınız</h2>
          <p>KVKK’nın 11. maddesi kapsamında, veri sahipleri;</p>
          <ul>
            <li>Verilerinin işlenip işlenmediğini öğrenme,</li>
            <li>İşlenmişse bilgi talep etme,</li>
            <li>Düzeltme veya silme talep etme</li>
          </ul>
          <p>
            haklarına sahiptir. KVKK’nın 11. maddesi gereği iletişim sayfasında yer alan iletişim adresine yazılı başvuruda bulunarak veya hazeljewellery.com üzerinden
            e-posta göndererek bu haklarınızı kullanabilirsiniz.
          </p>

          <q-banner dense class="bg-blue-1 text-caption q-mt-md">
            <q-icon name="info" color="primary" />
            "Okudum, Kabul Ediyorum" butonuna basarak, kişisel verilerinizin yurt dışına aktarılmasına özgür iradenizle <strong>açık rıza</strong> vermiş sayılırsınız.
          </q-banner>
        </div>
      </q-card-section>

      <q-separator />

      <q-card-actions align="right" class="q-pa-md">
        <q-btn flat label="Reddet" color="grey" @click="toggleDialog" />
        <q-btn unelevated label="Okudum, Kabul Ediyorum" color="primary" @click="accept" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<style scoped>
.scroll-area {
  max-height: 50vh;
  overflow-y: auto;
  padding-right: 10px;
}
h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
h2,
h3 {
  font-size: 16px;
  font-weight: 600;
  margin-top: 15px;
  margin-bottom: 5px;
  color: #333;
}
p,
ul {
  font-size: 14px;
  line-height: 1.5;
  color: #555;
}
ul {
  padding-left: 20px;
}
</style>
